import axios from 'axios';
import authHeader from './auth-header';
import { getUrl } from './service-utils';
import { UUIDTypes } from 'uuid';
import { ISearchBiasModel } from '../Models/search-bias.model';
import placesService, { IActivityBias } from './places.service';

const API_URL = getUrl();

/**
 * @deprecated Use placesService.getAutocompleteSuggestions() instead
 * Legacy wrapper for backward compatibility with existing components
 */
export const placesAutocomplete = async (
  input: string,
  sessionToken: UUIDTypes,
  bias?: ISearchBiasModel | null
) => {
  // Convert legacy bias format to new format
  const activityBias: IActivityBias | null = bias
    ? {
        lat: bias.lat!,
        lng: bias.lng!,
        radius: bias.radius || 50000
      }
    : null;

  const autocompleteData = await placesService.getAutocompleteSuggestions(
    input,
    sessionToken as string,
    activityBias
  );

  // Return in legacy format for backward compatibility
  // The backend returns { status, predictions } and we need to wrap it as { status: 'success', data: { suggestions: ... } }
  return {
    status: autocompleteData.status || 'success',
    data: {
      suggestions: autocompleteData.predictions || autocompleteData
    }
  };
};

/**
 * @deprecated Use placesService.getPlaceDetails() instead
 * Legacy wrapper for backward compatibility with existing components
 */
export const getPlaceDetails = async (
  placeId: string,
  sessionToken: UUIDTypes
) => {
  const place = await placesService.getPlaceDetails(
    placeId,
    sessionToken as string
  );

  // The backend already returns the place data in the expected format
  // { id, title, description, location: { latitude, longitude }, ... }
  return {
    status: 'success',
    data: place
  };
};

export const getPlaceDetailsImages = async (imagesLink: string) => {
  const tmpData = await axios.post(
    API_URL + 'maps/placedetails/images',
    { imagesLink: imagesLink },
    {
      headers: authHeader()
    }
  );
  return tmpData.data;
};

export const getActivityAndSimilar_ReturnDetails = async (
  selectionName: string,
  selectionTypes: string[],
  latitude: number,
  longitude: number,
  location: string,
  findRelated: boolean,
  selectionLocation?: string
) => {
  const tmpData = await axios.post(
    API_URL + `activities/searchActivities`,
    {
      selectionName: selectionName,
      selectionTypes: selectionTypes,
      latitude: latitude,
      longitude: longitude,
      location: location,
      findRelated: findRelated
    },
    {
      headers: authHeader()
    }
  );
  return tmpData.data;
};

export const getActivity_ReturnDetails = async (
  selectionName: string,
  selectionTypes: string[],
  latitude: number,
  longitude: number,
  location: string,
  findRelated: boolean,
  selectionLocation?: string,
  place_id?: string
) => {
  const tmpData = await axios.post(
    API_URL + `activities/searchActivitiesByPlaceId`,
    {
      selectionName: selectionName,
      selectionTypes: selectionTypes,
      latitude: latitude,
      longitude: longitude,
      location: location,
      findRelated: findRelated,
      place_id: place_id || ''
    },
    {
      headers: authHeader()
    }
  );
  return tmpData.data;
};

export const getMapMarkers = async (tripId: string, folderId?: string) => {
  const url = API_URL + `maps/mapmarkers/${tripId}`;
  const tmpData = await axios.get(url, {
    headers: authHeader()
  });
  return tmpData.data;
};
